module.exports = __webpack_public_path__ + "static/media/danielWalls.0ec67b05.png";